const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export function getErpWebAssetUrl(filename) {
    return `${API_BASE}/api/erpweb/webpage/${encodeURIComponent(filename)}`;
}

/** Top-level section nav: header + main-dashboard sidebar (order matters). */
export const SECTION_NAV_ITEMS = [
    { path: '/god/dashboard', name: 'GOD', logo: 'slglogo.png', matchPrefix: '/god' },
    { path: '/superman/dashboard', name: 'SUPERMAN', logo: 'supermanlogo.png', matchPrefix: '/superman' },
    { path: '/simon/dashboard', name: 'SIMON', logo: 'simonlogo.png', matchPrefix: '/simon' },
    {
        path: '/gz/dashboard',
        name: 'GZ',
        matchPrefix: '/gz',
        logo: 'gzlogo.png',
        children: [
            { path: '/gz/dashboard', name: 'GZ', logo: 'gzlogo.png' },
            { path: '/watch', name: 'Watch', external: true, matchPrefix: '/watch', logo: 'watchlogo.png' },
            { path: '/foweb', name: 'FO', external: true, matchPrefix: '/foweb', logo: 'Fologo.png' },
        ],
    },
    { path: '/sbf/dashboard', name: 'SBF', logo: 'sbflogo.jpg', matchPrefix: '/sbf' },
    { path: '/unblock/dashboard', name: 'UNBLOCK', logo: 'sgunblocklogo.png', matchPrefix: '/unblock' },
    { path: '/redirect/dashboard', name: 'REDIRECT', logo: 'redirectlogo.png', matchPrefix: '/redirect' },
    { path: '/analytics', name: 'ANALYTICS', logo: 'analyticslogo.png', matchPrefix: '/analytics' },
    {
        path: '/archived',
        name: 'ARCHIVED',
        matchPrefix: '/archived',
        logo: 'archivedlogo.png',
        children: [
            { path: '/ads/dashboard', name: 'ADS', logo: 'adslogo.png', matchPrefix: '/ads' },
            { path: '/assets/domains', name: 'ASSETS', logo: 'pendinglogo.png', matchPrefix: '/assets' },
            { path: '/sfrt/dashboard', name: 'SFRT', logo: 'sfrtlogo.png', matchPrefix: '/sfrt', strikethrough: true },
        ],
    },
];

export function getSectionLogoUrl(item) {
    return getErpWebAssetUrl(item.logo);
}

export function getWatchLogoUrl() {
    return getErpWebAssetUrl('watchlogo.png');
}

export function getFoLogoUrl() {
    return getErpWebAssetUrl('Fologo.png');
}

export function findSectionNavItem(matchPrefix) {
    for (const item of SECTION_NAV_ITEMS) {
        if (item.matchPrefix === matchPrefix) return item;
        const child = item.children?.find((c) => c.matchPrefix === matchPrefix);
        if (child) return child;
    }
    return undefined;
}

export function isSectionNavActive(pathname, item) {
    if (pathname.startsWith(item.matchPrefix)) return true;
    return Boolean(
        item.children?.some((child) => pathname.startsWith(child.matchPrefix || child.path))
    );
}
